import DtcControlEvent from "../components/controls/control_event.vue.js";
import _sfc_main$9 from "../components/controls/control_slot.vue.js";
import _sfc_main$8 from "../components/controls/control_dynamic.vue.js";
import _sfc_main$7 from "../components/controls/control_object.vue.js";
import _sfc_main$6 from "../components/controls/control_array.vue.js";
import _sfc_main$2 from "../components/controls/control_boolean.vue.js";
import _sfc_main$3 from "../components/controls/control_number.vue.js";
import _sfc_main$5 from "../components/controls/control_selection.vue.js";
import _sfc_main$4 from "../components/controls/control_string.vue.js";
import _sfc_main$1 from "../components/controls/control_nullish.vue.js";
import _sfc_main from "../components/controls/control_base.vue.js";
import { typeOfMemberValue } from "./utils.js";
const UNSET = Symbol("unset");
const controlMap = Object.freeze({
  event: {
    component: DtcControlEvent,
    default() {
      return null;
    }
  },
  slot: {
    component: _sfc_main$9,
    default() {
      return getControlDataDefault(this);
    }
  },
  dynamic: {
    component: _sfc_main$8,
    default() {
      return getControlDataDefault(this);
    },
    defaultControl() {
      return "undefined";
    },
    serialize: true
  },
  object: {
    component: _sfc_main$7,
    default() {
      return getControlDataDefault(this);
    }
  },
  array: {
    component: _sfc_main$6,
    default() {
      return getControlDataDefault(this);
    }
  },
  selection: {
    component: _sfc_main$5,
    default({ values } = {}) {
      return values == null ? void 0 : values[0];
    }
  },
  string: {
    component: _sfc_main$4,
    default() {
      return getControlDataDefault(this);
    }
  },
  number: {
    component: _sfc_main$3,
    default() {
      return getControlDataDefault(this);
    }
  },
  boolean: {
    component: _sfc_main$2,
    default() {
      return getControlDataDefault(this);
    }
  },
  null: {
    component: _sfc_main$1,
    default() {
      return getControlDataDefault(this);
    },
    serialize: true
  },
  base: {
    component: _sfc_main,
    default() {
      return getControlDataDefault(this);
    }
  }
});
function getControlDataDefault(controlData) {
  return controlData.component.props.value.default();
}
function getControlByValue(value) {
  const control = value === void 0 || value === null || value === UNSET ? "null" : typeOfMemberValue(value);
  return control in controlMap ? control : "base";
}
function getControlByMemberType(type, args) {
  switch (type) {
    case "string": {
      return (args == null ? void 0 : args.values) && args.values.length > 0 ? "selection" : "string";
    }
    default:
      return type;
  }
}
function serializeControlValue(value) {
  return value === void 0 ? UNSET : value;
}
function deserializeControlValue(value) {
  return value === UNSET ? void 0 : value;
}
export {
  UNSET,
  controlMap,
  deserializeControlValue,
  getControlByMemberType,
  getControlByValue,
  serializeControlValue
};
//# sourceMappingURL=control.js.map
